import React from "react";
const LeaderboardHeader = (props) => {
    return (React.createElement("div", { className: "pt-5 sticky-top bg-white" },
        React.createElement("div", { className: "d-flex justify-content-between border-bottom" },
            React.createElement("a", { onClick: props.goToTop, className: "btn-no-style primary-color small" }, "GO TO TOP"),
            React.createElement("a", { onClick: props.goToUser, className: "btn-no-style dark-grey small" }, "GO TO ME"),
            React.createElement("p", { className: "mb-0 small" }, "RANK"))));
};
export default LeaderboardHeader;
